import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const submitLead = (payload) => client.post("/leads", payload);
export const adminLogin = (email, password) => client.post("/auth/login", { email, password });
export const adminLogout = () => client.post("/auth/logout");
export const adminMe = () => client.get("/auth/me");
export const fetchLeads = (status) => client.get("/admin/leads", { params: status ? { status } : {} });
export const updateLeadStatus = (id, status) => client.patch(`/admin/leads/${id}`, { status });

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || "Něco se nepovedlo. Zkuste to znovu.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(detail);
};
